var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVeroGoLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3C5 1.9 5.9 1 7 1H24.5L34 10.5V37C34 38.1 33.1 39 32 39H7C5.9 39 5 38.1 5 37V3Z",
    stroke: "#2D2943",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 1V8.5C24.5 9.6 25.4 10.5 26.5 10.5H34",
    stroke: "#2D2943",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13L14 24H19L13 34L26 22H20Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeroGoLarge);
export default __webpack_public_path__ + "static/media/vero-go-large.342361e5.svg";
export { ForwardRef as ReactComponent };